import { z } from 'zod';

export const LEAVE_TYPES = [
  'casual',
  'sick',
  'earned',
  'maternity',
  'paternity',
  'unpaid',
] as const;
export const leaveTypeEnum = z.enum(LEAVE_TYPES);
export type LeaveType = z.infer<typeof leaveTypeEnum>;

export const LEAVE_REQUEST_STATUSES = ['pending', 'approved', 'rejected', 'cancelled'] as const;
export const leaveRequestStatusEnum = z.enum(LEAVE_REQUEST_STATUSES);
export type LeaveRequestStatus = z.infer<typeof leaveRequestStatusEnum>;

export const applyLeaveSchema = z
  .object({
    type: leaveTypeEnum,
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    reason: z.string().trim().min(5, 'Give a brief reason (min 5 characters)').max(500),
  })
  .refine((data) => data.endDate >= data.startDate, {
    message: 'End date must be on or after the start date',
    path: ['endDate'],
  });

export type ApplyLeaveInput = z.infer<typeof applyLeaveSchema>;

export const decideLeaveSchema = z.object({
  status: z.enum(['approved', 'rejected']),
  note: z.string().trim().max(500).optional(),
});

export type DecideLeaveInput = z.infer<typeof decideLeaveSchema>;

export const leaveListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  userId: z.string().optional(),
  status: leaveRequestStatusEnum.optional(),
  type: leaveTypeEnum.optional(),
});

export type LeaveListQuery = z.infer<typeof leaveListQuerySchema>;

export const createHolidaySchema = z.object({
  name: z.string().trim().min(2).max(120),
  date: z.coerce.date(),
  isOptional: z.boolean().default(false),
});

export type CreateHolidayInput = z.infer<typeof createHolidaySchema>;

export const updateHolidaySchema = createHolidaySchema.partial();
export type UpdateHolidayInput = z.infer<typeof updateHolidaySchema>;
